import { useEffect } from 'react';
import axios from 'axios';

import { API_ROUTES } from 'lib/api-routes';

const { NEXT_PUBLIC_API_HOST_URL } = process.env;
const API_URL = `${NEXT_PUBLIC_API_HOST_URL}${API_ROUTES.CANDIDATE}/extension_uninstall`;

const UninstallationTracking = function () {
  // useEffect to hit api with email and token and then redirect to survey page of Huzzle
  useEffect(() => {
    const params = new URL(location.href).searchParams;
    const email = params.get('email') || '';
    const token = params.get('token') || '';
    const postUninstallData = async () => {
      try {
        if (!email || !token) return;
        await axios.post(
          API_URL,
          {},
          {
            headers: {
              'X-Auth-Email': email,
              'X-Auth-Token': token,
            },
          }
        );
      } finally {
        window.location.href = `https://form.typeform.com/to/u8bVZTcS#email=${email}`;
      }
    };
    postUninstallData();
  }, []);

  return <></>;
};

export default UninstallationTracking;
